import { useNetworkStore } from '/src/store/stores/useNetworkStore.js';
import { useNativeNetwork } from '/src/native/useNativeNetwork.js';
import { useLogger } from '/src/composables/useLogger.js';
import { randomBetween } from '/src/utils/numbers.js';

const ONLINE_DELAY_MIN = 2 * 1000;
const ONLINE_DELAY_MAX = 5 * 1000;

// network store
const { setNetwork } = useNetworkStore();

// network
const {
	getStatus,
	addListener,
} = useNativeNetwork();

// logger
const { addActionLog } = useLogger();

export function useNetworkService () {
	let removeListener;
	let onlineTimeout = null;

	function clearOnlineTimeout () {
		if (onlineTimeout) {
			clearTimeout(onlineTimeout);
			onlineTimeout = null;
		}
	}

	function onStatusChange ({ connected }) {
		clearOnlineTimeout();

		if (!connected) {
			setNetwork(false);
			addActionLog('offline', { event: 'network-change' });
			return;
		}

		onlineTimeout = setTimeout(() => {
			onlineTimeout = null;
			setNetwork(true);
			addActionLog('online', { event: 'network-change' });
		}, randomBetween(ONLINE_DELAY_MIN, ONLINE_DELAY_MAX));
	}

	async function start () {
		stop();

		const { connected } = await getStatus();
		setNetwork(connected);

		addActionLog(connected ? 'online' : 'offline', { event: 'initial-status' });

		removeListener = addListener('networkStatusChange', onStatusChange);
	}

	function stop () {
		clearOnlineTimeout();

		if (removeListener) {
			removeListener();
			removeListener = null;
		}
	}

	return {
		start,
		stop,
	};
}
